import { useState } from "react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
import { Link, useLocation } from "react-router-dom";
//primeReact
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { BreadCrumb } from "primereact/breadcrumb";
import { confirmDialog } from "primereact/confirmdialog";
//components
import Panel from "../../../components/panel/panel";
import Input from "../../../components/input/Input";
import NumberInput from "../../../components/input/NumberInput";
import ExportTable from "../../../components/button/ExportButton";
//services
import { getIndexReadjustment } from "../../../services/GlobalRoles/getIndexReadjustment";
import { onSubmitIndexReadjustment } from "../../../services/Settings/Index/IndexReadjustment/createIndexReadjustment";
import { onSubmitDeleteIndexReadjustment } from "../../../services/Settings/Index/IndexReadjustment/deleteIndexReadjustment";
import usePermission from "../../../hooks/usePermission";
import { useAppContext } from "../../../context/AppContext";

const IndexInfo = (props) => {
  usePermission("153"); //Informar Correções do Indice
  const { permissions } = useAppContext();
  const location = useLocation();
  const rowData = location.state.rowData;

  const items = [
    {
      template: () => (
        <Link to={`/settings/index`} className="p-breadcrumb-link">
          {rowData.name}
        </Link>
      ),
    },
    {
      template: () => (
        <Link
          to={`/settings/index/IndexInfo`}
          state={{ rowData: rowData }}
          className="p-breadcrumb-link"
        >
          Correções
        </Link>
      ),
    },
  ];

  const home = {
    template: () => (
      <Link to={"/settings/index"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const [visible, setVisible] = useState(true);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [sendRowData, setSendRowData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tableToExport, setTableToExport] = useState(null);

  const {
    control: controlIndex,
    handleSubmit: handleSubmitIndex,
    reset: resetIndex,
    formState: { errors },
    setValue,
  } = useForm();

  const columns = [
    { field: "id", header: "ID", body: "hidden" },
    { field: "name", header: "Mês Referente" },
    { field: "index", header: "Índice" },
    { field: "fee", header: "Juros" },
  ];

  const onGlobalFilterChange = (e) => {
    setGlobalFilterValue(e.target.value);
  };

  const exportColumns = columns.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));

  var idIndex = rowData.id;
  var nameIndex = rowData.name;

  //create
  function sendSubmitIndex(data) {
    setVisible(false);
    onSubmitIndexReadjustment(resetIndex, setLoading, setVisible, data)
      .then(() => {
        resetIndex();
        refetch();
      })
      .catch((error) => {
        console.error("Erro ao enviar a conta corrente:", error);
      });
  }

  //delete
  function SubmitDeleteIndex(rowData) {
    setSendRowData(rowData);
    confirmDeleteIndex(rowData);
  }
  const confirmDeleteIndex = (selectedOptionDelete) => {
    var idType = selectedOptionDelete.id;
    confirmDialog({
      message: "Deseja fazer a exclusão?",
      header: "Confirmação",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: (event) => deleteIndexReadjustment(event, idType),
    });
  };
  const deleteIndexReadjustment = async (event, idType) => {
    onSubmitDeleteIndexReadjustment(
      resetIndex,
      setLoading,
      setVisible,
      idType,
      idIndex
    )
      .then(() => {
        resetIndex();
        refetch();
      })
      .catch((error) => {
        // Tratar errors
        console.error("Erro ao enviar a conta corrente:", error);
      });
  };

  //get
  const { data: indexReadjustment, refetch } = useQuery(
    "indexReadjustment",
    () => getIndexReadjustment(idIndex, setLoading),
    {
      onSuccess: () => setLoading(false),
      enabled: !!permissions?.includes("149"),
    }
  );
  // eslint-disable-next-line no-unused-vars
  const getFormErrorMessage = (name) => {
    return errors[name] ? (
      <small className="p-error">{errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };

  useEffect(() => {
    if (idIndex) {
      // Para os campos de tipo de cadastro
      setValue("index_id", idIndex);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idIndex, onSubmitIndexReadjustment]);

  useEffect(() => {
    if (indexReadjustment) {
      // console.log(indexReadjustment);
      const dataWithoutIds = indexReadjustment.map((t) => ({
        ID: t.id,
        MesReferencia: t.name,
        Indice: t.index,
        Juros: t.fee,
      }));
      // console.log("sem ids", dataWithoutIds);
      setTableToExport(dataWithoutIds);
    }
  }, [indexReadjustment]);

  return (
    <>
      <div className="col-md-4">
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>

      <Panel title="Informações">
        <form onSubmit={handleSubmitIndex(sendSubmitIndex)}>
          <div className="d-flex row mt-2">
            <Input
              className="d-none"
              control={controlIndex}
              name="index_id"
              id="index_id"
              isRequired={true}
              defaultValue={idIndex}
            />
            <div className="col-xl-4 col-md-6 form-group">
              <Input
                className="w-100"
                control={controlIndex}
                errors={errors}
                isRequired={true}
                name="name"
                label="Mês / Ano*"
                id="name"
              />
            </div>

            <div className="col-xl-3 col-md-6 form-group">
              <NumberInput
                suffix="%"
                placeholder="0%"
                name="index"
                control={controlIndex}
                errors={errors}
                label="Índice*"
                max={100}
                minFractionDigits={2}
                maxFractionDigits={2}
                required={true}
              />
            </div>

            <div className="col-xl-3 col-md-6 form-group">
              <NumberInput
                suffix="%"
                placeholder="0%"
                name="fee"
                control={controlIndex}
                errors={errors}
                label="Juros*"
                max={100}
                minFractionDigits={2}
                maxFractionDigits={2}
                required={true}
              />
            </div>

            <div className="col-xl-2 col-md-6 mt-3 form-group">
              <Button
                loading={loading}
                type="submit"
                icon="fa fa-plus"
                label="Cadastrar"
                aria-label="Search"
                className={`rounded-3 w-100`}
              />
            </div>
          </div>
        </form>
      </Panel>

      <Panel
        mainCss="mt-4"
        title={`Cadastro do Índice de Reajuste ${nameIndex}`}
      >
        <div>
          <hr className="my-4" />
          <ExportTable
            tableData={tableToExport}
            exportColumns={exportColumns}
            onGlobalFilterChange={onGlobalFilterChange}
            globalFilterValue={globalFilterValue}
          />
          <DataTable
            stripedRows
            showGridlines
            sortMode="multiple"
            selectionMode="single"
            value={indexReadjustment}
            paginator
            // loading={loading}
            rows={12}
            sortableColumns={false}
            rowsPerPageOptions={[12, 24, 36]}
            globalFilter={globalFilterValue}
            emptyMessage="Nenhuma Informação foi encontrada."
            tableStyle={{
              minWidth: "1rem",
              fontSize: "0.8rem",
              border: "0.8rem",
            }}
          >
            {columns.map((col) => (
              <Column
                sortable
                key={col.field}
                body={(rowData) => rowData[col.field]} // Ajuste aqui
                field={col.field}
                header={col.header}
              />
            ))}
            {permissions &&
              permissions.includes("152") && ( // Excluir Indice
                <Column
                  header="Excluir Índice"
                  body={(rowData) => (
                    <div className="text-center">
                      <button
                        className="btn btn-danger btn-btn-sm"
                        onClick={() => SubmitDeleteIndex(rowData)}
                      >
                        <i className="fa-solid fa-trash-can"></i>
                      </button>
                    </div>
                  )}
                />
              )}
          </DataTable>
        </div>
      </Panel>
    </>
  );
};

export default IndexInfo;
